import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  useToast,
} from "alm-react-components";
import { confirmSignIn, fetchUserAttributes, signIn } from "aws-amplify/auth";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import {
  ActionType,
  APPROUTES,
  constants,
  corporateKeys,
  ParamMeters,
  StatusCode,
} from "../../../assets/constants/constants";
import {
  analytics_category,
  analytics_event,
  analytics_label,
  appcues_event,
} from "../../../assets/constants/staticContentConstants";
import eye from "../../../assets/images/eye.svg";
import eyeslash from "../../../assets/images/eyeslash.svg";
import { AppContext } from "../../../context/AppProvider";
import useGaEventTracking from "../../../hooks/UseGaEventTracking";
import {
  allStorage,
  authSession,
  clearLocalStorage,
  encrptText,
} from "../../../lib/utils";
import { apis } from "../../../services/alm";
import {
  deviceDetails,
  getAlmToken,
  getSllUser,
  sendStorageToBakend,
} from "../../../services/user";
import { putAppCuesData } from "../../../lib/appcues";
type Inputs = {
  newPassword: string;
  confirmNewPassword: string;
};

const SetupPassword = () => {
  const [error, setError] = useState("");
  const [revealed, setRevealed] = useState(false);
  const [confrimPassword, setConfirmPassword] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const gaEventTracker = useGaEventTracking();
  const [query] = useSearchParams();

  const sessionExpire: any = query.get(ParamMeters.sessionExpire);

  useEffect(() => {
    // Remove exiting session when component unmounts
    const checkUser = async () => {
      // Check if user is already logged in. If so, redirect to home page. Else, remove the existing session and clear the context.
      const accessToken = await authSession();
      if (accessToken !== undefined) {
        navigate(APPROUTES.home);
      } else if (!state?.corporateDetails?.username) {
        // Remove existing session when user logs out
        await clearLocalStorage(sessionExpire);
        navigate("/");
      }
    };
    // Check user when component mounts or when session expires
    checkUser();
  }, []);

  async function onhandleSubmitCode(values: any) {

    //admin    //
    const confirmNewPassword = encrptText(values.confirmNewPassword);
    confirmSignIn({
      challengeResponse: confirmNewPassword,
    })
      .then(async () => {
        toast({
          description: t("ResetPasswordForm.passwordUpdateSuccessMsg"),
          variant: "success",
        });
        dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: true });
        const accessToken = await authSession();
        localStorage.setItem("token", accessToken ? accessToken : "");
        fetchUserAttributes().then(async (userAttributes: any) => {
          //Set token
          await getSllUser(userAttributes.email).then(async (res: any) => {
            const data = res.data;
            const items = {
              value: null,
              currency: null,
              transaction_id: null,
              items: [{}],
              userId: data.userId,
              login_method: constants.Custom,
              device: constants.WEB,
            };
            gaEventTracker(
              analytics_event.login,
              analytics_category.buttonCLickLogin,
              analytics_label.loginLabel,
              items
            );

            dispatch({ type: ActionType.IS_AUTH, payload: true });
            if (res.status === StatusCode.SUCCESS) {
              putAppCuesData({
                event_Name: appcues_event.login,
                eventName: appcues_event.login,
                userId: data?.email,
                time_since_last_login: data?.lastLoggedIn,
                email: data?.email
              })
              if (res?.data?.roles.includes(corporateKeys.CORPORATE_OWNER)) {
                setAccoutDataAndRedrection(true);
              } else if (
                res?.data?.roles.includes(corporateKeys.CORPORATE_LEARNER)
              ) {
                setAccoutDataAndRedrection(false);
              }
            }
          });
        });
      })
      .catch((error) => {
        if (error.name == "UserNotFoundException") {
          setError(t("Validations.userNotFoundError"));
        } else if (error.name == "ExpiredCodeException") {
          setError(t("Validations.codeExpiredError"));
        } else if (error.name == "CodeMismatchException") {
          setError(t("Validations.invalidVerification"));
        } else if (error.name == "LimitExceededException") {
          setError(t("Validations.attemptLimitError"));
        } else if (error.name == "NotAuthorizedException") {
          // call sign if Authentication flow session duration expire
          reSignIn(values);
        } else {
          setError(error.name);
        }
      });
  }

  const reSignIn = (values: any) => {
    const params = {
      username: state?.corporateDetails?.username,
      password: state?.corporateDetails?.password,
    };

    signIn(params).then(() => {
      onhandleSubmitCode(values);
    });
  };
  const setAccoutDataAndRedrection = async (corporate: boolean) => {
    const language = localStorage.getItem("locale") || constants.dutchLocale;
    const languageCode = localStorage.getItem("i18nextLng") || constants.dutchCode;
    await deviceDetails(constants.login);
    getAlmToken()
      .then(async (learnerRes: any) => {
        if (learnerRes.status === StatusCode.SUCCESS) {
          localStorage.setItem(
            "access_token",
            learnerRes.data.access_token ? learnerRes.data.access_token : ""
          );
          const now = new Date();
          localStorage.setItem("login_time", now.toISOString());
          await apis.checkAlmUser().then(async () => {
            // const userLanguage = res?.data?.attributes?.uiLocale;
            // if (!userLanguage || userLanguage !== language) {
              localStorage.setItem("i18nextLng", languageCode);
              localStorage.setItem("locale", language);
            //   await apis.updateUserContent(learnerRes?.data?.user_id, language);
            //   await updateLanguageSetting(language);
            //   i18n.changeLanguage(languageCode);
            // }
            if (corporate) {
              sessionStorage.removeItem("lastActiveTimestamp");
              sessionStorage.removeItem("popupExpiryTimestamp");
              await sendStorageToBakend(allStorage());
              window.open( `${corporateKeys?.CORPORATE_URL}?awsToken=${localStorage.getItem( "token")}`, "_self");
            } else {
              dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
              navigate(APPROUTES.profile);
            }
          });
        } else {
          /// error handling
        }
      })
      .catch(() => {
        dispatch({
          type: ActionType.LOTTIE_ANIMATION,
          payload: false,
        });
      });
  };
  const schema2 = yup.object({
    newPassword: yup
      .string()
      .required(t("Validations.passwordRequired"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t("Validations.msgPasswordValidation")
      ),
    confirmNewPassword: yup
      .string()
      .required(t("Validations.confirmPasswordRequired"))
      .oneOf([yup.ref("newPassword")], t("Validations.passwordNotMatch"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t("Validations.msgPasswordValidation")
      ),
  });
  const form2 = useForm<Inputs>({
    resolver: yupResolver(schema2),
    mode: "onChange",
    defaultValues: {
      newPassword: "",
      confirmNewPassword: "",
    },
  });
  const handleChange = () => {
    if (form2.getValues("confirmNewPassword")) {
      form2.trigger("confirmNewPassword");
    }
  };

  return (
    <>
      <div className="min-w-[420px] max-w-[420px] md:min-w-[486px] md:max-w-[486px]  px-4 mx-auto">
        <Card className="text-base border-0 bg-transparent pt-8 lg:pt-[56px] xl:pt-[86px]">
          <CardHeader className="block space-y-0 p-0">
            <CardTitle className="text-2xl lg:text-[32px] font-notoLight font-light pb-16">
              {t("UpdatePassword.setupPassword")}
            </CardTitle>
          </CardHeader>
          <CardContent className="px-0">
            <Form {...form2}>
              <form
                onSubmit={form2.handleSubmit(onhandleSubmitCode)}
                onChange={handleChange}
                className=""
              >
                <div className="grid w-full items-center gap-4 mb-6">
                  <div className="flex flex-col space-y-1.5 text-base">
                    <FormField
                      control={form2.control}
                      name="newPassword"
                      render={({ field }) => (
                        <FormItem className="relative">
                          <FormLabel className="text-sm font-normal tracking-wider">
                            {t("UpdatePassword.newPassword")} *
                          </FormLabel>
                          <FormControl>
                            <Input
                              type={revealed ? "text" : "password"}
                              placeholder={t("UpdatePassword.newPlaceHolder")}
                              {...field}
                              className="h-auto py-4 text-base pe-16 opacity-100 text-white placeholder:text-white dark:text-white dark:placeholder:text-white"
                            />
                          </FormControl>
                          {revealed ? (
                            <>
                              <img
                                className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                                onClick={() => setRevealed(!revealed)}
                                src={eye}
                                alt="No image"
                              />
                            </>
                          ) : (
                            <>
                              <img
                                className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                                onClick={() => setRevealed(!revealed)}
                                src={eyeslash}
                                alt="No image"
                              />
                            </>
                          )}
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div className="flex flex-col space-y-1.5 text-base">
                    <FormField
                      control={form2.control}
                      name="confirmNewPassword"
                      render={({ field }) => (
                        <FormItem className="relative">
                          <FormLabel className="text-sm font-normal tracking-wider">
                            {t("UpdatePassword.confirmNewPassword")} *
                          </FormLabel>
                          <FormControl>
                            <Input
                              type={confrimPassword ? "text" : "password"}
                              placeholder={t(
                                "UpdatePassword.confirmPlaceHolder"
                              )}
                              {...field}
                              className="h-auto py-4 text-base pe-16 opacity-100 text-white placeholder:text-white dark:text-white dark:placeholder:text-white"
                            />
                          </FormControl>
                          {confrimPassword ? (
                            <>
                              <img
                                className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                                onClick={() =>
                                  setConfirmPassword(!confrimPassword)
                                }
                                src={eye}
                                alt="No image"
                              />
                            </>
                          ) : (
                            <>
                              <img
                                className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                                onClick={() =>
                                  setConfirmPassword(!confrimPassword)
                                }
                                src={eyeslash}
                                alt="No image"
                              />
                            </>
                          )}
                          <FormMessage>{error}</FormMessage>
                        </FormItem>
                      )}
                    />
                  </div>
                </div>
                <Button
                  className="w-full h-auto py-2 text-base mb-4 truncate block"
                  dangerouslySetInnerHTML={{
                    __html: t("LogIn.resetPassword"),
                  }}
                />
                {/* )} */}
              </form>
            </Form>
          </CardContent>
        </Card>
      </div>
      {/* <ErrorDisplay description={description} /> */}
    </>
  );
};

export default SetupPassword;
